function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L0,18.0000563 C5.14116069,18.0000563 9.61945797,20.8220651 12.0218417,25.0060781 L12.0218417,25.0060781 L27.4999009,16.00005 L0,0 Z",
  id: "path-1"
}), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "96.9293951%",
  y1: "36.5205775%",
  x2: "26.2150666%",
  y2: "86.8100559%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C5C7",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECECEC",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5F00\\u53D1\\u8005\\u670D\\u52A1\\u5E73\\u53F0\\u7B2C\\u4E09\\u7A3F",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7B2C\\u4E09\\u7A3F-5",
  transform: "translate(-933.000000, -1556.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-17\\u5907\\u4EFD-3",
  transform: "translate(0.000000, 1360.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "decorative-icon-capacity",
  transform: "translate(933.000000, 196.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "\\u5F62\\u72B6\\u7ED3\\u5408",
  fill: "#1C8AEC",
  fillRule: "nonzero",
  points: "27.4999008 0.000100000312 27.4999008 31.9997 54.9998016 16.00065 54.9998016 47.99975 27.499967 63.9981667 27.5000993 64 27.4999008 63.9998 27.4989085 63.9981667 0.00105846453 47.9991834 0 48.0002499 0 16.0001499"
}), /*#__PURE__*/React.createElement("g", {
  id: "Fill-4-Clipped",
  transform: "translate(27.500099, 0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L0,18.0000563 C5.14116069,18.0000563 9.61945797,20.8220651 12.0218417,25.0060781 L12.0218417,25.0060781 L27.4999009,16.00005 L0,0 Z",
  id: "Fill-4",
  fill: "url(#linearGradient-3)",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4",
  transform: "translate(7.368700, 11.712936)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.2620061,20.2870634 C40.2620061,31.4920984 31.2488499,40.5741268 20.1310031,40.5741268 C9.01315625,40.5741268 0,31.4920984 0,20.2870634 C0,9.08302839 9.01315625,0 20.1310031,0 C31.2488499,0 40.2620061,9.08302839 40.2620061,20.2870634",
  id: "Fill-6",
  fill: "#EDEDED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.1309038,20.2870634 L20.1309038,6.28701965 C12.4593513,6.28701965 6.23855687,12.5550392 6.23855687,20.2870634 C6.23855687,28.0190876 12.4593513,34.2871071 20.1309038,34.2871071 C27.8034486,34.2871071 34.0232508,28.0190876 34.0232508,20.2870634 C34.0232508,17.7360554 33.3365719,15.352048 32.1527455,13.2920415 L20.1309038,20.2870634 Z",
  id: "Fill-8",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.1530432,13.2924415 C29.7506595,9.10842847 25.2723622,6.28741965 20.1312015,6.28741965 L20.1312015,20.2874634 L32.1530432,13.2924415 Z",
  id: "Fill-10",
  fill: "#A1CDF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0924563,20.2870634 C25.0924563,23.049072 22.8716654,25.287079 20.1309038,25.287079 C17.3911345,25.287079 15.1693513,23.049072 15.1693513,20.2870634 C15.1693513,17.5260548 17.3911345,15.2870478 20.1309038,15.2870478 C22.8716654,15.2870478 25.0924563,17.5260548 25.0924563,20.2870634",
  id: "Fill-12",
  fill: "#181818"
}))))));

function SvgDecorativeIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "64px",
    viewBox: "0 0 55 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6D4B\u8BD5\u670D\u52A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeIcon2);
export default __webpack_public_path__ + "static/media/decorative-icon-2.caeeac4f.svg";
export { ForwardRef as ReactComponent };